import React, { lazy } from "react"
import { MENU_SCREEN } from "@/features/menu/routes/route-list.ts"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"

const MenuPage = React.lazy(
  () => import("@/features/menu/views/menu-page/menu-page.tsx"),
)
const BottomMenuLayout = lazy(
  () => import("@/layouts/bottom-menu-layout/bottom-menu-layout.tsx"),
)

export const bottomLayoutMenuRoutes = [
  {
    path: MENU_SCREEN,
    element: <MenuPage />,
  },
]

const MOBILE_MENU_ROUTES = [
  {
    element: <BottomMenuLayout />,
    children: bottomLayoutMenuRoutes,
  },
]

const DESKTOP_MENU_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: bottomLayoutMenuRoutes,
  },
]

export const getMenuRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_MENU_ROUTES : MOBILE_MENU_ROUTES
}
